<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DnrRtf/tc-custom/9780802192516.jpg?1708745740428" alt="This image is the cover for the book Euphoria"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Euphoria
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>New York Times</i> Bestseller: An “enthralling,” prize-winning novel of a love triangle among three young archaeologists in 1930s New Guinea (<i>Vogue</i>).</b><br/><br/><i>Winner of the Kirkus Prize</i><br/><i>Winner of the New England Book Award for Fiction</i><br/><i>Finalist for the National Book Critics Circle Award</i><br/><br/> Named a Best Book of the Year by: <i>The New York Times Book Review</i>, <i>Time</i>, NPR, <i>Washington Post</i>, <i>Entertainment Weekly</i>, <i>Newsday</i>, <i>Vogue</i>, <i>New York Magazine</i>, <i>Seattle Times</i>, <i>San Francisco Chronicle</i>, <i>Wall Street Journal</i>, <i>Boston Globe</i>,<i> Kirkus Reviews</i>, <i>Publishers Weekly</i>, <i>Oprah.com, Salon</i><br/><br/> From the author of <i>Writers &amp; Lovers</i> and <i>Five Tuesdays in Winter</i>, <i>Euphoria</i> follows three young, gifted anthropologists caught in a passionate love triangle that threatens their bonds, their careers, and, ultimately, their lives. Inspired by events in the life of revolutionary anthropologist Margaret Mead, <i>Euphoria</i> is “dazzling . . . suspenseful . . . brilliant . . . an exhilarating novel” (<i>The Boston Globe</i>).<br/><br/> “A thrilling read.” —<i>Publishers Weekly</i> (starred review)<br/><br/> “Atmospheric and sensual.” —NPR<br/><br/> “A taut, witty, fiercely intelligent tale of competing egos and desires in a landscape of exotic menace. . . . Exquisite.” —<i>The New York Times Book Review</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lily King
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d2b30ec